import React from 'react';
import PropTypes from 'prop-types';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress} from "material-ui";
import {connect} from "react-redux";
import {
    clearTaskError,
    closePostTaskFetch,
    closePutTaskFetch,
    createTask,
    updateTask
} from "../../../redux/actions/tasks";
import {TaskForm} from "../../../forms/task";
import {closeGetUsersFetch, getUsers} from "../../../redux/actions/users";
import {snackMessageShow} from "../../../redux/actions/snack_message";

export class TaskDialog extends React.Component {

    state = {
        companyId: undefined
    };

    componentDidMount = () => {
        this.props.initialize();
    };

    componentDidUpdate = (status) => {
        if (this.state.companyId !== status.activeCompanyId && status.activeCompanyId !== undefined && status.activeCompanyId !== 0) {
            this.setState({companyId: status.activeCompanyId});
            this.props.getUsers(status.activeCompanyId);
        }
    };

    handleClose = () => {
        this.props.handleClose();
        setTimeout(() => {
            this.props.initialize();
        }, 10);
    };

    handleSubmit = (values) => {

        values = {
            ...values,
            author_id: this.props.currentUser.id,
        };

        if (this.props.task.id === undefined) {
            this.props.createTask({
                ...values,
                status: 1,
            }, this.props.activeCompanyId, this.handleClose);
        } else {
            this.props.updateTask(values, this.handleClose);
        }
    };

    onClickSubmit = () => {
        this.refs.taskForm.submit();
    };

    render() {

        const {open, task, errors, users, isPostTaskFetch, isPutTaskFetch} = this.props;

        return (
            <Dialog
                open={open}>

                {task.id === undefined ? <DialogTitle id="form-dialog-title">新規課題登録</DialogTitle> : null}
                {task.id !== undefined ? <DialogTitle id="form-dialog-title">課題更新</DialogTitle> : null}


                <DialogContent>
                    <TaskForm
                        errors={errors}
                        onSubmit={this.handleSubmit}
                        ref="taskForm"
                        initialValues={task}
                        users={users}/>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="default" disabled={isPostTaskFetch}>
                        キャンセル
                    </Button>

                    {task.id === undefined ?
                        <Button onClick={this.onClickSubmit} color="primary" disabled={isPostTaskFetch}>
                            新規登録
                        </Button>
                        : null}

                    {task.id !== undefined ?
                        <Button onClick={this.onClickSubmit} color="primary" disabled={isPutTaskFetch}>
                            アップデート
                        </Button>
                        : null}

                </DialogActions>
                {isPostTaskFetch ? <LinearProgress/> : null}
            </Dialog>
        );
    }
}

TaskDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
};

TaskDialog = connect(
    (state) => {
        return {
            currentUser: state.users.currentUser,
            task: state.tasks.task,
            users: state.users.users,
            errors: state.tasks.errors,
            isPostTaskFetch: state.users.isPostTaskFetch,
            activeCompanyId: state.app.activeCompanyId,
        }
    },
    (dispatch) => {
        return {
            initialize: () => {
                dispatch(clearTaskError());
            },
            createTask: (task, companyId, callback) => {
                dispatch(createTask(task, companyId)).then((response) => {
                    setTimeout(() => {
                        dispatch(closePostTaskFetch());
                        switch (response.type) {
                            case 'API_CREATE_TASK_FAIL':
                                dispatch(snackMessageShow('課題の作成に失敗しました'));
                                break;
                            default:
                                dispatch(snackMessageShow('新規課題を作成しました'));
                                callback();
                        }
                    }, 300);

                });
            },

            updateTask: (task, callback) => {
                dispatch(updateTask(task)).then((response) => {
                    setTimeout(() => {
                        dispatch(closePutTaskFetch());
                        switch (response.type) {
                            case 'API_UPDATE_TASK_FAIL':
                                dispatch(snackMessageShow('課題の更新に失敗しました'));
                                break;
                            default:
                                dispatch(snackMessageShow('課題を更新しました'));
                                callback();
                        }
                    }, 300);

                });
            },

            getUsers: (company_id) => {
                dispatch(getUsers(company_id)).then(() => {
                    dispatch(closeGetUsersFetch());
                });
            },
        }
    }
)(TaskDialog);


// WEBPACK FOOTER //
// ./src/containers/task/dialog/index.js